var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdviserNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9922,
    cy: 56.7041,
    r: 35,
    stroke: "#081E56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 92C37.67 92 22 76.33 22 57",
    stroke: "#081E56",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102C77.8781 102 95.4353 87.7818 100.517 68.5M12 57C12 32.1472 32.1472 12 57 12C74.6686 12 89.9589 22.1828 97.3224 37",
    stroke: "#FDE966",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2C87.3757 2 112 26.6243 112 57C112 59.7172 111.803 62.3884 111.422 65M14.1636 22.5C6.55503 31.9351 2 43.9356 2 57C2 85.3482 23.4468 108.687 51 111.676",
    stroke: "#F4F4F9",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8477 76.2041H53.7002V53.8975C53.7002 53.2822 53.709 52.5264 53.7266 51.6299C53.7441 50.7158 53.7705 49.7842 53.8057 48.835C53.8408 47.8682 53.876 46.998 53.9111 46.2246C53.7178 46.4531 53.3223 46.8486 52.7246 47.4111C52.1445 47.9561 51.5996 48.4482 51.0898 48.8877L46.6602 52.4473L42.7314 47.543L55.1504 37.6553H61.8477V76.2041Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviserNumber1);
export default __webpack_public_path__ + "static/media/Adviser-Number1.e61372066cf339211fe2d2c6605269da.svg";
export { ForwardRef as ReactComponent };